var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgKindHost = function SvgKindHost(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 40 40"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#kind-host_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M19.56 18.99c-2.172-1.91-6.692-6.169-7.387-7.931-.869-2.203-.23-4.25 1.304-5.288 1.303-.881 4.346-1.322 6.084 1.763 1.738-3.085 4.78-2.644 6.084-1.763 1.534 1.037 2.173 3.085 1.304 5.288-.696 1.762-5.215 6.022-7.388 7.931Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#010101",
    d: "M10.766 31.674v-6.942c.506-.344 2.026-1.084 4.052-1.29 2.026-.207 6.078.947 7.85 1.55.338-.431 1.419-1.448 3.04-2.068s2.364.259 2.532.775c0-.172.355-.568 1.773-.775 1.418-.206 1.604.775 1.52 1.292 1.895-1.505 2.91-1.674 3.039.258.058.866-.253 1.808-.76 2.325-2.28 1.636-7.192 5.167-8.61 6.2-1.774 1.292-4.038 1.212-5.304 1.212-1.013 0-6.178-1.762-9.132-2.537"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#kind-host_svg__b)",
    fillOpacity: 0.4,
    d: "M10.766 31.674v-6.942c.506-.344 2.026-1.084 4.052-1.29 2.026-.207 6.078.947 7.85 1.55.338-.431 1.419-1.448 3.04-2.068s2.364.259 2.532.775c0-.172.355-.568 1.773-.775 1.418-.206 1.604.775 1.52 1.292 1.895-1.505 2.91-1.674 3.039.258.058.866-.253 1.808-.76 2.325-2.28 1.636-7.192 5.167-8.61 6.2-1.774 1.292-4.038 1.212-5.304 1.212-1.013 0-6.178-1.762-9.132-2.537"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#000",
    strokeWidth: 0.507,
    d: "M24.017 21.132c.873-.437 1.674-.347 2.258-.069.29.139.527.324.696.516q.044.053.086.108.11-.097.262-.19c.364-.217.918-.392 1.715-.392.603 0 1.045.305 1.317.68.162.223.27.48.317.727.64-.283 1.175-.387 1.651-.323.568.078 1.008.388 1.417.805.433.441.304 1.051.088 1.52-.224.486-.596.948-.869 1.226l-.015.017-.018.012a2766 2766 0 0 0-8.852 6.377c-1.866 1.36-3.22 1.642-4.576 1.642-.292 0-.912-.106-1.691-.266a99 99 0 0 1-2.827-.637 289 289 0 0 1-5.962-1.496l-.19-.05v-8.036l.112-.076c.555-.377 2.158-1.153 4.283-1.37 1.087-.11 2.686.143 4.216.49 1.448.33 2.866.752 3.794 1.061.399-.51 1.205-1.485 2.788-2.276Z"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 3.044,
    height: 13.868,
    x: 6.367,
    y: 20.344,
    fill: "#111",
    rx: 0.676
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeWidth: 0.507,
    d: "m24.469 24.063 2.748-2.463m-1.062 4.833 4.813-4.06m-9.719 1.015c1.804.676 5.073 1.69 3.551 3.382-.225.17-.845 1.015-3.044.338-1.533-.471-4.397-1.69-4.904-1.69"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "kind-host_svg__b",
    x1: 38.017,
    x2: 6.806,
    y1: 25.91,
    y2: 0.124,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "kind-host_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h40v40H0z"
  })))));
};
export default SvgKindHost;